import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { UploadZipService } from 'src/app/services/upload-zip/upload-zip.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { XlsxViewComponent } from 'src/app/shared/xlsx-view/xlsx-view.component';
import { ExcelModel, GapExcelModel } from '../shared/models/geography';
import { UpdateMobileModel } from '../shared/models/User';

@Component({
  selector: 'app-gap-analysis-new-user',
  templateUrl: './gap-analysis-new-user.component.html',
  styleUrls: ['./gap-analysis-new-user.component.scss']
})
export class GapAnalysisNewUserComponent implements OnInit {
  tempOptionModel: any;
  excelFileName: string;
  excel: GapExcelModel = new GapExcelModel();
  uploadFileSubscribe: any;
  files: FileList;
  totaldata : any;

  constructor(private modalService: NgbModal,
    public exportExcelService: ExportExcelService,
    public toast: ToastClientService,
    private xlsx: XlsxService,
    public alertService: AlertService,
    private uploadFile: UploadZipService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    public ngxService: NgxUiLoaderService)
    { }

  ngOnInit() {
  }

  /** Add new brands section */
  showuploadTemplateModal(targetModal) {
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }
  closeoptionModel() {
    this.tempOptionModel.close();
  }

  downloadExcel() {
    this.exportExcelService.GapAnalysisNewUserExcelTemplate();
  }

  uploadXlsx(eve) {
    if (eve.target.files) {
      this.excelFileName = eve.target.files[0].name;
    }
    this.xlsx.uploadXlsx(eve).then((res) => {
      this.xlsxView(res);
    });
  }
  xlsxView(data) {
    this.closeoptionModel();
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        console.log("XlsxViewComponent::", result);
        if (result.length > 0) {
          this.excel.gap_input_data = result;
          this.excel.gap_upload = 2;
          //this.enableUploadDiv(this.excel);
          this.uploadToServer(result);
        }
      },
      (reason) => { }
    );
  }

  enableUploadDiv(data) {
    this.uploadFile.changeMessage({
      status: "upload",
      data: data,
      url: this.apiConfig.submitGapAnalysis,
      module: "Users",
      zip: "no",
      excelname: this.excelFileName,
    });
  }


  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

  uploadToServer(files: FileList) {
    this.loaderStart();
    this.uploadFileSubscribe = this.apiService.post(this.apiConfig.submitGapAnalysis, this.excel).subscribe(event => {
      if (event.type === HttpEventType.UploadProgress) {
        console.log("response received");
      } else if (event instanceof HttpResponse) {
        if (event.body.data) {
          // this.uploadedStatus = event.body.data;
          this.exportExcelService.GapAnalysisNewUserExcel(event.body.data)
          // this.uploadFile.responseData(this.uploadedStatus);
          this.loaderDismiss();
          this.clearSuccess();debugger
          this.totaldata = event.body.data;
        }
      }
    }, err => {
      console.log('err', err);
      this.toast.Error(err.error.data.message);
      this.loaderDismiss();
    });
  }

  loaderStart() {
    try {
      this.ngxService.start();
    } catch (error) {
      console.log(error);
    }
  }
  loaderDismiss() {
    try {
      // this.loadingCntr.dismiss();
      this.ngxService.stop();
    } catch (error) {}
  }


}
